import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // How long data stays fresh before being considered stale
      staleTime: 5 * 60 * 1000, // 5 minutes

      // How long unused/inactive cache data is kept in memory
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)

      // Don't refetch on window focus by default (we'll handle via unreadCount)
      refetchOnWindowFocus: false,

      // Don't refetch on reconnect (WebSocket handles real-time updates)
      refetchOnReconnect: false,

      // Don't refetch on mount (we'll use smart invalidation)
      refetchOnMount: false,

      // Retry failed requests once
      retry: 1,

      // Show cached data while fetching new data in background
      placeholderData: (previousData: any) => previousData,
    },
    mutations: {
      retry: 1,
    },
  },
});
